export const GET_ALL_PROSPECTS = "GET_ALL_PROSPECTS"
export const GET_ALL_PROSPECTS_SUCCESS = "GET_ALL_PROSPECTS_SUCCESS"
export const GET_ALL_PROSPECTS_ERROR = "GET_ALL_PROSPECTS_ERROR"
export const UPDATE_CPA_DISPOSITION = "UPDATE_CPA_DISPOSITION"
export const UPDATE_CPA_DISPOSITION_SUCCESS = "UPDATE_CPA_DISPOSITION_SUCCESS"
export const UPDATE_CPA_DISPOSITION_ERROR = "UPDATE_CPA_DISPOSITION_ERROR"
export const BULK_EDIT_CPA_DISPOSITION = "BULK_EDIT_CPA_DISPOSITION"
export const BULK_EDIT_CPA_DISPOSITION_SUCCESS = "BULK_EDIT_CPA_DISPOSITION_SUCCESS"
export const BULK_EDIT_CPA_DISPOSITION_ERROR = "BULK_EDIT_CPA_DISPOSITION_ERROR"
export const GET_CPA_BULK_EDIT_STATUS = "GET_CPA_BULK_EDIT_STATUS"
export const GET_CPA_BULK_EDIT_STATUS_SUCCESS = "GET_CPA_BULK_EDIT_STATUS_SUCCESS"
export const GET_CPA_BULK_EDIT_STATUS_ERROR = "GET_CPA_BULK_EDIT_STATUS_ERROR"
export const PREVIEW_CPA_BULK_EDIT = "PREVIEW_CPA_BULK_EDIT"
export const PREVIEW_CPA_BULK_EDIT_SUCCESS = "PREVIEW_CPA_BULK_EDIT_SUCCESS"
export const PREVIEW_CPA_BULK_EDIT_ERROR = "PREVIEW_CPA_BULK_EDIT_ERROR"
export const RESET_CPA_BULK_EDIT_PREVIEW = "RESET_CPA_BULK_EDIT_PREVIEW"
